import { HFBKeys, ServiceKeys, type hfb, type service } from "@repo/api";
import { sortRecordByValue } from "@repo/utils";

import { useSettings } from "../settings/SettingsProvider";
import { translateHFB } from "../utils/translationHelpers";
import { mapStores, useStores } from "./stores";

export const useOrderedDepartments = (): [hfb, string][] => {
  const departments = Object.fromEntries(
    HFBKeys.map((key) => [key, translateHFB(key)])
  ) as Record<hfb, string>;

  return [
    ["hfb07", departments.hfb07],
    ["hfb04", departments.hfb04],
    ["hfb97", departments.hfb97],
    ["hfb02", departments.hfb02],
    ["hfb01", departments.hfb01],
    ["hfb05", departments.hfb05],
    ["hfb03", departments.hfb03],
    ["hfb06", departments.hfb06],
    ["hfb09", departments.hfb09],
    ["hfb18", departments.hfb18],
    ["hfb08", departments.hfb08],
    ["hfb70", departments.hfb70],
    ["hfb10", departments.hfb10],
    ["hfb16", departments.hfb16],
    ["hfb11", departments.hfb11],
    ["hfb14", departments.hfb14],
    ["hfb17", departments.hfb17],
    ["hfb12", departments.hfb12],
    ["hfb15", departments.hfb15],
    ["hfb13", departments.hfb13],
    ["hfb19", departments.hfb19],
    ["hfb50", departments.hfb50],
    ["hfb96", departments.hfb96],
    ["hfb1001", departments.hfb1001],
  ];
};

export const useBokaHfbs = (): [string, string][] => {
  const defaultDepartments = useOrderedDepartments();
  const { boka_config } = useSettings();

  if (!boka_config?.hfb_configuration?.hfb_list) {
    return defaultDepartments;
  }

  return boka_config.hfb_configuration.hfb_list
    .filter((item) => item.hfb_code_key !== undefined)
    .map((item) => [item.hfb_code_key!, translateHFB(item.hfb_code_key)]);
};

export const useServices = () => {
  return Object.fromEntries(
    Object.entries(ServiceKeys).map(([key, value]) => [key, value])
  ) as Record<service, string>;
};

export const useOrderedServices = () => {
  const services = useServices();
  const { language } = useSettings();

  return sortRecordByValue(services, language);
};

export const useOrderedCustomerMeetingPoints = (): {
  data: [string, string][];
  isLoading: boolean;
} => {
  const { data: stores, isLoading } = useStores();
  const storesData = mapStores(stores);
  const { language } = useSettings();

  return {
    data: sortRecordByValue<string>(storesData ?? {}, language),
    isLoading,
  };
};
